import i18nService, { FormatFunction } from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';
import { setLocale } from 'yup';
import { BRANDS, getBrand } from 'hooks/useBrand';
import ru from '../translations/ru.json';
import en from '../translations/en.json';
import pl from '../translations/pl.json';

const format: FormatFunction = (value: string, formatType, lang) => {
  switch (formatType) {
    case 'number':
      if (typeof value !== 'number') return value;
      return new Intl.NumberFormat(lang).format(value);
    default:
      return value;
  }
};

export const LANGUAGES = {
  ru: {
    // eslint-disable-next-line lingui/no-unlocalized-strings
    label: 'Русский'
  },
  en: {
    label: 'English'
  },
  pl: {
    label: 'Polski'
  }
};

const BRAND = getBrand();

export type Lang = keyof typeof LANGUAGES;

i18nService
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en,
      ru,
      pl
    },
    supportedLngs: Object.keys(LANGUAGES).filter((lang) => {
      if (BRAND === BRANDS.WODOMAT) return lang !== 'ru';
      return true;
    }),
    fallbackLng: 'en',
    appendNamespaceToCIMode: true,
    appendNamespaceToMissingKey: true,
    detection: {
      lookupLocalStorage: 'lng'
    },
    interpolation: {
      escapeValue: false,
      format
    }
  })
  .catch(console.error);

export const i18n = i18nService;

const setYupTranslations = () => {
  setLocale({
    mixed: {
      default: i18n.t('validation:invalid'),
      required: i18n.t('validation:required'),
      notType: () => i18n.t('validation:notType')
    },
    number: {
      min: (params) => i18n.t('validation:min', { min: params.min }),
      max: (params) => i18n.t('validation:max', { max: params.max }),
      moreThan: (params) => i18n.t('validation:moreThan', { min: params.more }),
      lessThan: (params) => i18n.t('validation:lessThan', { max: params.less })
    },
    string: {
      length: (params) => i18n.t('validation:length', { length: params.length })
    }
  });
};
setYupTranslations();

i18n.on('languageChanged', (lng: Lang) => {
  try {
    localStorage.setItem('lng', lng);
    setYupTranslations();
  } catch (e) {
    console.error(e);
  }
});
